import React from "react";

export default function Haftung() {
  const currentYear = new Date().getFullYear();

  return (
    <div
      style={{
        padding: "3rem 2rem",
        maxWidth: "900px",
        margin: "0 auto",
        lineHeight: "1.6",
        fontFamily: "'Inter', Arial, sans-serif",
        color: "#222",
      }}
    >
      {/* HEADER */}
      <header style={{ borderBottom: "3px solid #d44", marginBottom: "2rem" }}>
        <div className="pt-6" />
        <h1 style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>
          Haftung & Nutzungshinweise
        </h1>
        <p style={{ color: "#666", marginBottom: "1rem" }}>
          Rechtliche Hinweise zur Nutzung dieser Website und der automatisierten GeoReports
        </p>
      </header>

      {/* --- Geltungsbereich --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          1. Geltungsbereich
        </h2>
        <p>
          Die nachfolgenden Hinweise gelten für die Nutzung dieser Website sowie
          für alle bereitgestellten automatisierten Standort- und GeoReports
          (nachfolgend „Reports“ genannt).
        </p>
        <p>
          Mit der Nutzung der Website oder dem Erwerb eines Reports erkennen
          Sie diese Hinweise als verbindlich an.
        </p>
      </section>

      {/* --- Art der bereitgestellten Inhalte --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          2. Art der bereitgestellten Inhalte
        </h2>
        <p>
          Die Inhalte dieser Website und die erzeugten Reports stellen
          <strong> automatisierte, datenbasierte Auswertungen</strong> dar.
          Sie dienen ausschließlich der allgemeinen Information und
          standortbezogenen Orientierung.
        </p>
        <p>
          Die Berechnungen und Bewertungen basieren auf:
        </p>
        <ul>
          <li>vereinfachten Modellannahmen</li>
          <li>typischen Referenzwerten</li>
          <li>öffentlich zugänglichen Geodaten</li>
          <li>algorithmischer Verarbeitung ohne individuelle Fachprüfung</li>
        </ul>
      </section>

      {/* --- Keine Fachplanung / kein Gutachten --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          3. Keine Fachplanung, kein Gutachten
        </h2>
        <p>
          Die bereitgestellten Inhalte ersetzen ausdrücklich:
        </p>
        <ul>
          <li>keine Fachplanung nach VDI 4640</li>
          <li>kein Baugrund- oder Bodengutachten</li>
          <li>keine Genehmigungs- oder Behördenprüfung</li>
          <li>keine individuelle Energie-, Förder- oder Rechtsberatung</li>
        </ul>
        <p>
          Für die konkrete Planung, Auslegung und Umsetzung von Bau- oder
          Sanierungsvorhaben sind stets qualifizierte Fachplaner,
          Installationsbetriebe sowie zuständige Behörden einzubeziehen.
        </p>
      </section>

      {/* --- Nutzung auf eigene Verantwortung --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          4. Nutzung auf eigene Verantwortung
        </h2>
        <p>
          Die Nutzung der bereitgestellten Informationen erfolgt auf eigene
          Verantwortung. Entscheidungen oder Maßnahmen, die auf Grundlage der
          dargestellten Inhalte getroffen werden, liegen ausschließlich im
          Verantwortungsbereich der Nutzerinnen und Nutzer.
        </p>
        <p>
          Eine Haftung für wirtschaftliche, technische oder rechtliche Folgen,
          die aus der Nutzung der Inhalte entstehen, ist ausgeschlossen,
          soweit gesetzlich zulässig.
        </p>
      </section>

      {/* --- Haftungsbeschränkung --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          5. Haftungsbeschränkung
        </h2>
        <p>
          Es wird keine Gewähr für die Aktualität, Vollständigkeit,
          Richtigkeit oder dauerhafte Verfügbarkeit der bereitgestellten
          Inhalte übernommen.
        </p>
        <p>
          Die Haftung für einfache Fahrlässigkeit ist ausgeschlossen,
          sofern keine wesentlichen Vertragspflichten verletzt werden
          und keine Schäden aus der Verletzung von Leben, Körper oder
          Gesundheit resultieren.
        </p>
      </section>

      {/* --- Externe Datenquellen --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          6. Externe Datenquellen
        </h2>
        <p>
          Die Standortbewertungen beruhen teilweise auf Daten externer
          Geodatenanbieter (z. B. Landesbehörden, OpenStreetMap).
        </p>
        <p>
          Für die Verfügbarkeit, Aktualität und inhaltliche Richtigkeit
          dieser Datenquellen wird keine Haftung übernommen.
        </p>
      </section>

      {/* --- Änderungen --- */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ color: "#d44", fontSize: "1.4rem" }}>
          7. Änderungen der Inhalte
        </h2>
        <p>
          Die Inhalte dieser Website sowie die zugrunde liegenden
          Berechnungsmodelle können jederzeit angepasst, erweitert oder
          geändert werden. Ein Anspruch auf unveränderte Bereitstellung
          besteht nicht.
        </p>
      </section>

      {/* --- Footer --- */}
      <footer style={{ borderTop: "1px solid #ddd", paddingTop: "1rem", color: "#555" }}>
        <p>
          © {currentYear} Dr.-Ing. Eike Radeisen – Erdwärme-Experten. Alle Rechte vorbehalten.
        </p>
      </footer>
    </div>
  );
}
